export const LISTAR_CHAMADAS = 'LISTAR_CHAMADAS'
export const LISTAR_CENTRO_DE_CUSTOS = 'LISTAR_CENTRO_DE_CUSTOS'
export const LISTAR_CONFERENCIAS = 'LISTAR_CONFERENCIAS'
export const LISTAR_TAGS = 'LISTAR_TAGS'
export const GERAR_DADOS_RELATORIO = 'GERAR_DADOS_RELATORIO'
